import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { List, ListItem, ListItemText, MenuItem, Box } from "@mui/material";

import { DATE_FORMAT } from "../../../../../../constants";
import { CopyToClipboard } from "../../../../../../components/ui";

const TableBody = (): React.ReactElement => {
  const { data } = useSelector((state) => state.suspiciousCustomers);

  return (
    <tbody>
      {data.map(({ id, name, email, suspicious_accounts_notes, banned_account }) => {
        return (
          <Box
            component="tr"
            key={id}
            sx={banned_account ? { backgroundColor: "#F88F703b" } : {}}
          >
            <td>{id}</td>
            <td>
              <MenuItem
                component={Link}
                to={`/customer/${id}`}
                sx={{ whiteSpace: "break-spaces" }}
              >
                {name}
              </MenuItem>
            </td>
            <td>
              <CopyToClipboard value={email} />
            </td>
            <td>
              <List>
                {banned_account && (
                  <ListItemText>
                    Banned on: {moment(banned_account.timestamp).format(DATE_FORMAT)}
                  </ListItemText>
                )}
                {suspicious_accounts_notes.map(({ id, note }) => (
                  <ListItem sx={{ paddingLeft: 0, paddingTop: 0, paddingBottom: 0 }} key={id}>
                    <ListItemText>- {note}</ListItemText>
                  </ListItem>
                ))}
              </List>
            </td>
          </Box>
        );
      })}
    </tbody>
  );
};

export default TableBody;
